// extracted by mini-css-extract-plugin
export default {"nowrap":"zlkf5","icon":"OaPVk"};